import { SearchByBoundsParams, SearchByBoundsResponse } from '../types/CarwashType';

const API_URL = process.env.REACT_APP_API_URL;

export async function searchCarwashesByBounds(
  params: SearchByBoundsParams
): Promise<SearchByBoundsResponse> {
  const query = new URLSearchParams();

  query.set('ne_lat', String(params.ne_lat));
  query.set('ne_lng', String(params.ne_lng));
  query.set('sw_lat', String(params.sw_lat));
  query.set('sw_lng', String(params.sw_lng));

  if (params.search) query.set('search', params.search);
  if (params.city) query.set('city', params.city);
  if (params.state) query.set('state', params.state);
  if (params.plan) query.set('plan', params.plan);
  if (params.service) query.set('service', params.service);
  if (params.rating) query.set('rating', params.rating);
  if (params.additionalService) query.set('additionalService', params.additionalService);
  if (params.order) query.set('order', params.order);
  if (params.serveProfessionalDriver !== undefined)
    query.set('serveProfessionalDriver', String(params.serveProfessionalDriver));
  if (params.categoryId !== undefined) query.set('categoryId', String(params.categoryId));
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.limit !== undefined) query.set('limit', String(params.limit));

  const response = await fetch(`${API_URL}carwashes/search-by-bounds?${query.toString()}`);

  if (!response.ok) {
    throw new Error('Erro ao buscar parceiros na região');
  }

  return response.json();
}
